// Standard error display with retry capability.
// Used across all pages for consistent error handling.

import { AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ErrorStateProps {
  message: string
  technicalDetail?: string
  onRetry?: () => void
}

export function ErrorState({ message, technicalDetail, onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center space-y-4 p-8">
      <AlertCircle className="h-12 w-12 text-destructive" />
      <div className="space-y-2 text-center">
        <h3 className="text-lg font-semibold">{message}</h3>
        {technicalDetail && <p className="text-sm text-muted-foreground">{technicalDetail}</p>}
      </div>
      {onRetry && (
        <Button onClick={onRetry} variant="outline">
          Try Again
        </Button>
      )}
    </div>
  )
}
